module.exports = __webpack_public_path__ + "static/media/file-mp3.eb04a0b5.svg";